/* eslint-disable react/prop-types */
/* eslint-disable no-console */
import React, { useEffect, useMemo, useState } from "react";
import {
  EXCEL_FILE_TYPE,
  IMAGE_FILE_TYPE,
  PDF_FILE_TYPE,
  VIEW_OFFICE_APP_LINK
} from "./constants";
import { NoPreview } from "./NoPreview";
import { PDFViewer } from "./PDFViewer";

export const DocumentViewer = (props) => {
  const {
    document,
    downloadDocument,
    theme,
    highlightChecked,
    documentDispatch,
    onChangeHighlightSelect,
    reuploadFile,
    captureDocNotReq,
    showHighlight
  } = props;
  const [presignedURL, setPresignedURL] = useState("");
  const fetchPresignedURL = async () => {
    try {
      if (!document?.path) return;
      const payload = {
        path: document?.path
      };
      const fetchedUrl = await downloadDocument(payload);
      setPresignedURL(fetchedUrl.data);
    } catch (error) {
      console.error("Error fetching presigned URL:", error);
    }
  };

  const encodedURL = useMemo(() => {
    if (!document || !presignedURL) return "";
    if (!EXCEL_FILE_TYPE.includes(document.fileType?.toLowerCase())) return "";
    const eUrl = encodeURIComponent(presignedURL);
    const urlPath = `${VIEW_OFFICE_APP_LINK}?src=${eUrl}`;
    return urlPath;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [presignedURL]);

  useEffect(() => {
    if (!document) return;
    fetchPresignedURL();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document?.id]);

  const renderFile = () => {
    if (!document) {
      return (
        <div
          style={{
            textAlign: "center",
            position: "relative",
            top: "50%",
            fontSize: 16,
            fontWeight: "bold"
          }}
        >
          Select a Document to Preview
        </div>
      );
    }
    if (IMAGE_FILE_TYPE?.includes(document?.fileType?.toLowerCase())) {
      return (
        <img
          src={presignedURL}
          alt={document.name}
          style={{
            width: "100%"
          }}
        />
      );
    }
    if (EXCEL_FILE_TYPE.includes(document.fileType?.toLowerCase())) {
      return (
        <iframe
          id='xlsIframe'
          title='unique'
          src={encodedURL}
          width='100%'
          height='100%'
        />
      );
    }
    if (PDF_FILE_TYPE.includes(document.fileType?.toLowerCase())) {
      return (
        <PDFViewer
          state={document}
          setState={documentDispatch}
          cacheKey={document.id}
          captureDocNotReq={captureDocNotReq}
          name={document.name}
          url={presignedURL}
          downloadDocument={downloadDocument}
          theme={theme}
          highlightChecked={highlightChecked}
          onChangeHighlightSelect={onChangeHighlightSelect}
          getDocumentFromServer={downloadDocument}
          reuploadFile={reuploadFile}
          showHighlight={showHighlight}
        />
      );
    }
    return <NoPreview url={presignedURL} name={document.name} />;
  };

  return <>{renderFile()}</>;
};
